import { Component, OnInit } from '@angular/core';
import { SessionContext } from '../../../core/services/config/app.settings';
import { Routes } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RefCampagnesService } from '../../../data/declaration/services/ref-campagnes/ref-campagnes.service';
import { DeclarationsService } from '../../../data/declaration/services/declarations/declarations.service';
import { switchMap, tap } from 'rxjs/operators';
import { SyntheseDrev } from '../../../data/declaration/models/synthese-drev.model';
import { forkJoin } from 'rxjs';
import { LoaderService } from '../../../core/services/loader/loader.service';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'app-drev-synthese',
    templateUrl: './drev-synthese.component.html',
    styleUrls: ['./drev-synthese.component.scss'],
    standalone: true,
    imports: [SharedModule]
})
export class DrevSyntheseComponent implements OnInit {
    /**
     * Routes
     */
    static routes: Routes = [
        {
            path: '',
            redirectTo: 'liste',
            pathMatch: 'full',
            data: {
                role: 'ORGANISME && DECLARATION_MOUVEMENT_LECTURE',
                menu: { icon: '', libelle: 'menu.drev-synthese', hide: true }
            }
        },
        {
            path: 'liste',
            component: DrevSyntheseComponent
        }
    ];

    /**
     * Get idOrganisme from session context
     */
    get idOrganisme() {
        return SessionContext.get('idOrganisme');
    }

    /**
     * Search forme
     */
    public searchForm: FormGroup;

    /**
     * Getter annee
     */
    get annee() {
        return this.searchForm.get('annee');
    }

    /**
     * Dynamique table columns
     */
    columns = [
        { field: 'libelle', label: 'AOC / Produit' },
        { field: 'nbDR', label: 'Nb DR' },
        { field: 'surface', label: 'Surface (ha)' },
        { field: 'volRevendicable', label: 'Vol. revendicable (hl)' },
        { field: 'vciNouveau', label: 'VCI nouveau (hl)' },
        { field: 'nbDREV', label: 'Nb DREV' },
        { field: 'volTotalRevendique', label: 'Vol. total revendiqué (hl)' },
        { field: 'volRevendiqueCourant', label: 'Vol. revendiqué N (hl)' },
        { field: 'vciRevendiquePasse', label: 'VCI revendiqué N-1 (hl)' },
        { field: 'vsiReserve', label: 'Réserve VSI (hl)' }
    ];

    /**
     * Synthèse de DREV par cahier des charges
     */
    syntheseCahier: SyntheseDrev[] = [];

    /**
     * Synthese de DREV par produit
     */
    syntheseProduit: SyntheseDrev[] = [];

    constructor(
        private readonly fb: FormBuilder,
        private readonly refCampagnesService: RefCampagnesService,
        private readonly declarationsService: DeclarationsService,
        private readonly loaderService: LoaderService
    ) {}

    /**
     * On init component
     */
    ngOnInit() {
        // Instancier le formulaire de recherche
        this.searchForm = this.fb.group({
            annee: [undefined, Validators.required]
        });

        this.refCampagnesService
            .getCampagneEnCours()
            .pipe(
                tap(campagne => this.annee.setValue(campagne.annee.toString())),
                switchMap(campagne =>
                    forkJoin([
                        this.declarationsService.getSyntheseDrevByCahier(this.idOrganisme, campagne.annee.toString()),
                        this.declarationsService.getSyntheseDrevByProduit(this.idOrganisme, campagne.annee.toString())
                    ])
                ),
                this.loaderService.operator()
            )
            .subscribe(([cahiers, produits]) => {
                this.syntheseCahier = cahiers;
                this.syntheseProduit = produits;
            });
    }

    /**
     * Search
     */
    search() {
        forkJoin([
            this.declarationsService.getSyntheseDrevByCahier(this.idOrganisme, this.annee.value),
            this.declarationsService.getSyntheseDrevByProduit(this.idOrganisme, this.annee.value)
        ])
            .pipe(this.loaderService.operator())
            .subscribe(([cahiers, produits]) => {
                this.syntheseCahier = cahiers;
                this.syntheseProduit = produits;
            });
    }

    /**
     * Get produits of cahiers
     * @param cahierId - Cahier id
     */
    getProduitsOfCahiers(cahierId: number) {
        return this.syntheseProduit.filter(produit => produit.idCahier === cahierId);
    }
}
